import React from 'react';
import ReactDOM from 'react-dom/client';
import { ColorModeProvider } from './theme/ColorModeContext';
import './utils/damlSyntax';
import './utils/cairoSyntax';
import './index.css';
import App from './App';
import { captureAttribution } from './utils/attribution';

// Before anything navigates, so the landing path and referrer are the real ones.
captureAttribution();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <App />
    </ColorModeProvider>
  </React.StrictMode>
);
